module.exports = __webpack_public_path__ + "img/logo_bandeau_haut.ac1af868.png";